import { render, staticRenderFns } from "./SlideShowSection.vue?vue&type=template&id=4312f1ba&scoped=true&"
import script from "./SlideShowSection.vue?vue&type=script&lang=js&"
export * from "./SlideShowSection.vue?vue&type=script&lang=js&"
import style0 from "./SlideShowSection.vue?vue&type=style&index=0&id=4312f1ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4312f1ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
